export default function () {
  window.location.replace('https://direct-book.com/properties/posadaelcapullodirect')
  return null
}



// WEBPACK FOOTER //
// ./src/book/index.js